<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  isCollapsed: {
    type: Boolean,
    default: false,
  },
  expandable: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <div
    class="flex items-center gap-2 px-2 py-1.5 rounded-2xl h-8 text-n-slate-10 select-none group/separator"
    :class="{
      'cursor-pointer hover:bg-n-alpha-1 hover:text-n-slate-12': expandable,
      'pointer-events-none': !expandable,
    }"
    @click="expandable && emit('toggle')"
  >
    <Icon v-if="icon" :icon="icon" class="size-4" />
    <span class="text-sm font-medium leading-5 flex-grow truncate">
      {{ label }}
    </span>
    <Icon
      v-if="expandable"
      icon="i-lucide-chevron-down"
      class="size-4 text-n-slate-9 transition-transform duration-200 opacity-0 group-hover/separator:opacity-100"
      :class="{ '-rotate-90': isCollapsed }"
    />
  </div>
</template>
